import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import WorkTypePopup from "./WorkTypePopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { WorkTypeDDL } from "../../../../Components/CommonDDL/WorkTypeDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from "../../../../Helper/Loading"
import { WorkTypeDeleteAPI, WorkTypeTableDataAPI } from "../../../../Redux/SidebarMasterSlice/WorkTypeSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { M_ELEC_Work_DeleteAPI, WorkTypeEleMasterTableDataAPI } from "../../../../Redux/ElectricalWorkTypeSlice/ElectricalWorkTypeSlice"
import { ElEWorkTypeDDL } from "../../../../Components/CommonDDL/ElEWorkTypeDDL"
import { WorkSubType } from "./WorkSubType"
import { ElEWorkSubTypeDDL } from "../../../../Components/CommonDDL/ElEWorkSubTypeDDL"
import { ElEWorkNameDDL } from "../../../../Components/CommonDDL/ElEWorkNameDDL"
import { ElEWorkTypeEleMasterTableDataAPI, M_ELEC_WorkType_DeleteAPI } from "../../../../Redux/ElectricalWorkTypeSlice/ElEWorkTypeSlice"


export const WorkType = () => {

    const [WorkTypePopupShow, setWorkTypePopupShow] = useState()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    const DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWorkTypePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setWorkTypePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWorkTypePopupShow(false)
    }


    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkNameType, setWorkNameType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })
    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkSubType({
            ...WorkSubType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkNameType({
            ...WorkNameType,
            ID: 0,
            Label: 'Select...',
        })

    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }


    // const handleShowImage = (img) => {
    //     setshowImagePopup(true)
    //     setImagePopUpData(img)
    // }

    useEffect(() => {
        if (DashboardName == "Electrical") {
            const data = {
                WorkTypeName: '',
                M_ELEC_WorkTypeID: WorkType.ID,
                M_UserID: UserID,
                token: token,
                From: From,
                To: To,
            }
            dispatch(ElEWorkTypeEleMasterTableDataAPI({ data }))
        }
        else {
            const data = {
                M_WorkTypeID: WorkType.ID,
                workTypeName: '',
                M_UserID: UserID,
                token: token,
                From: From,
                To: To,
                Flag: ApiFlag,
            }
            dispatch(WorkTypeTableDataAPI({ data }))
        }

    }, [IsPost, To, IsClear, isSearch, WorkType.ID, WorkNameType?.ID, WorkSubType?.ID])

    const { tableData, isLoading } = useSelector(state => DashboardName == "Electrical" ? state.ElEWorkTypeEleMasterTableData : state.WorkTypeTableData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [WorkType.ID])

    const handleDeleteApi = (item) => {
        if (DashboardName == "Electrical") {
            const data = {
                M_ELEC_WorkTypeID: item.m_eleC_WorkTypeID,
                M_UserID: UserID,
                token: token,
                Flag: 'Delete',
                handleIsPost: handleIsPost
            }
            dispatch(M_ELEC_WorkType_DeleteAPI({ data }))
        } else {
            const data = {
                M_WorkTypeID: item.m_WorkTypeID,
                M_UserID: UserID,
                token: token,
                Flag: 'Delete',
                handleIsPost: handleIsPost
            }
            dispatch(WorkTypeDeleteAPI({ data }))
        }
    }
    const { isDeleteLoading } = useSelector(state => DashboardName == "Electrical" ? state.M_ELEC_Work_DeleteData : state.WorkTypeDeleteData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    // console.log("WorkType", WorkType.ID)

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId} active='worktype' listActive={ProjectTypeId == 5 ? "gardenMaster" : ProjectTypeId == 8 ? "elec0trical" : "" }  />
                    <div className="content">
                        {/* <!-- [ breadcrumb ] start --> */}
                        <div className="page-header ">
                            <div className="page-block">
                                <div className="row align-items-center">
                                    <div className="col-md-12">
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- [ Main Content ] start --> */}
                        <div className="data_mob">
                            <div className="row m-1 py-1 pb-4 master_border">

                                 <div className='col-12 row'>
                                    <div className="col-12 col-lg-5">
                                        <h5 className="ps-1 pt-2 ps-2">Work Type Master</h5>
                                    </div>

                                    <div className="col-12 col-lg-3">
                                        <h5 className="ps-1 py-1">Total Count =
                                            <text style={{ color: '#048A8B', fontSize: '18px' }}>
                                                &nbsp;{tableData && tableData.table && tableData.table.length > 0 && tableData.table[0]?.totalCount ? tableData.table[0]?.totalCount :'0'}
                                            </text>
                                        </h5>
                                    </div>

                                    <div className="col-12 col-lg-4 float-end mt-4 pt-1">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>

                                

                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                {
                                                    DashboardName == "Electrical" ?
                                                        <>
                                                            <div className="col-12 col-md-4 col-lg-3">

                                                                <ElEWorkTypeDDL
                                                                    WorkType={WorkType}
                                                                    setWorkType={setWorkType}
                                                                    IsPost={IsPost}
                                                                    isDisplay={true}
                                                                    ApiFlag="Master"
                                                                />

                                                            </div>

                                                        </>
                                                        :
                                                        <div className="col-12 col-md-4 col-lg-3">

                                                            <WorkTypeDDL
                                                                WorkType={WorkType}
                                                                setWorkType={setWorkType}
                                                                IsPost={IsPost}
                                                                isDisplay={true}
                                                            />

                                                        </div>
                                                }

                                                <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex">
                                                    {/* <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button> */}
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                                {/* <div className="col-12 col-lg-6" ><button type="button" style={{ float: 'right', marginTop: "-0.2em" }} className="btn-clear btn btn-primary">Clear</button></div> */}
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Work Type</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}> <span >
                                                                        {/* <WorkTypePopup
                                                                            open={WorkTypePopupShow}
                                                                            item={item}
                                                                            EditIcon='Update'
                                                                            Flag='Update'
                                                                            handleIsPost={handleIsPost}
                                                                        /> */}
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>
                                                                    </span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                            item={item}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    WorkTypePopupShow ?
                        <WorkTypePopup
                            open={WorkTypePopupShow}
                            popupHeading="Location Name"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashboardName={DashboardName}
                        />
                        : <></>
                }
            </div>
        </>

    )
}